import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigComponent } from '../../config/config';

/*
  Generated class for the UtilsServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class UserServiceProvider {

    constructor(
        public http: HttpClient,
        private config: ConfigComponent,
    ) {
        console.log('Hello UtilsServiceProvider Provider');
    }

    getStudiante(cedula) {
        const headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        // const url = this.config.getUrlOmt() + 'MYJView/' + cedula;
        const url = this.config.getUrlOmt() + 'estudiante/' + cedula;
        // const url = this.config.getUrlOmt() + 'estudiantes/' + cedula;
        // const url = this.config.getUrlOmt() + 'estudiantes/';
        return this.http.get(url, {headers: headers});
    }

}



// WEBPACK FOOTER //
// /home/xpro/Documentos/ances/myjangular/src/app/layout/service/user-service.ts